import { useQuery, UseQueryOptions } from '@tanstack/react-query'

import {
  HubspotCompaniesResponse,
  HubspotCompany,
  organizationHubspotClient
} from '@/api/organization-hubspot-client'

export enum HUBSPOT_QUERY_IDS {
  GET_HUBSPOT_COMPANIES = 'HUBSPOT_GET_COMPANIES',
  GET_HUBSPOT_COMPANY_BY_ID = 'HUBSPOT_GET_COMPANY_BY_ID'
}

export const useQueryGetHubspotCompanies = (
  search?: string,
  limit?: number,
  opts?: Partial<UseQueryOptions<HubspotCompaniesResponse>>
) => {
  return useQuery<HubspotCompaniesResponse>({
    queryKey: [HUBSPOT_QUERY_IDS.GET_HUBSPOT_COMPANIES, search, limit],
    queryFn: () => organizationHubspotClient.getHubspotCompanies(search, limit),
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000, // 5 minutes
    ...opts
  })
}

export const useQueryGetHubspotCompanyById = (
  companyId: string | undefined,
  opts?: Partial<UseQueryOptions<HubspotCompany | null>>
) => {
  return useQuery<HubspotCompany | null>({
    queryKey: [HUBSPOT_QUERY_IDS.GET_HUBSPOT_COMPANY_BY_ID, companyId],
    queryFn: () =>
      companyId
        ? organizationHubspotClient.getHubspotCompanyById(companyId)
        : null,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000, // 5 minutes
    enabled: Boolean(companyId),
    ...opts
  })
}
